import {StyledTextField} from '@resurs-internal/mui';
import {useTranslate} from 'hooks';
import {
  Control,
  FieldValues,
  useController,
  UseControllerProps,
} from 'react-hook-form';

interface FeedbackTextFieldProps<T extends FieldValues>
  extends UseControllerProps<T> {
  control: Control<T>;
}

export const FeedbackTextField = <T extends FieldValues>({
  control,
  name,
  ...rest
}: FeedbackTextFieldProps<T>) => {
  const translate = useTranslate();
  const {field, formState} = useController({
    name,
    control,
    rules: {
      maxLength: 500,
      pattern: /^(?!\s*$).+/,
    },
  });
  const isError = Boolean(formState.errors.text);

  return (
    <StyledTextField
      id="feedback_input"
      placeholder={translate('feedback.text.field.placeholder')}
      label={translate('common.message')}
      name={field.name}
      onChange={field.onChange}
      onBlur={field.onBlur}
      value={field.value ?? ''}
      ref={field.ref}
      multiline
      fullWidth
      error={isError}
      sx={{
        paddingX: 2,
        paddingY: 1,
        minHeight: 100,
      }}
      {...rest}
    />
  );
};
